export default __webpack_public_path__ + "static/media/edit.b5f37c7f.png";